//External Libraries
import * as React from "react";
import { PINEntrySuccess } from "ouisys-clients/dist/clients/tallyman.v1-pin/HOC";

//Translations
import { Translate, injectIntl } from "../../localization/index";

import { useState } from "react";

//SCSS
import "./ThankYouStep.scss";

const ThankYouStep = ({ finalUrl, tracker }: PINEntrySuccess & {tracker:ITracker}) => {
	const [isLinkClicked, setLinkClicked] = useState<boolean>(false)

	React.useEffect(()=>{
		setTimeout(() => {

			if(typeof window != "undefined" && isLinkClicked === false){
				tracker.advancedInFlow("tallyman.v1-pin", "portal-redirect", {finalUrl})

				window.location.href = finalUrl;
			}
		}, 2000);

	},[])

return <div className="thank-you">
	<h3><Translate id="congratsTitle" defaultMessage="Congratulations!" /></h3>
	<p><Translate id="congratsText" defaultMessage="You have successfully enrolled in the service." /></p>
	<a onClick={()=>{setLinkClicked(true); tracker.advancedInFlow("tallyman.v1-pin", "portal-redirect", {finalUrl})}} href={finalUrl} className="btn"><Translate id="portalBtnText" defaultMessage="Go to portal page" /></a>
</div>
}

export default injectIntl(ThankYouStep);